import { PROJECT_THEME } from '../../theme'

const INDIGO: [string, string, string] = [PROJECT_THEME.colour.COLOUR_MID_DARK, '#3E3866', '#4A4479'];

type CubeProps = {
    x: number;
    y: number;
    size: number;
    spin: number;
    tint: [string, string, string];
};

// Isometric cube, spun in the picture plane so it reads as mid-tumble
function TumblingCube({ x, y, size, spin, tint }: CubeProps) {
    const w = size * 0.866;
    const top = `${x},${y - size} ${x + w},${y - size / 2} ${x},${y} ${x - w},${y - size / 2}`;
    const left = `${x - w},${y - size / 2} ${x},${y} ${x},${y + size} ${x - w},${y + size / 2}`;
    const right = `${x + w},${y - size / 2} ${x},${y} ${x},${y + size} ${x + w},${y + size / 2}`;
    return (
        <g transform={`rotate(${spin} ${x} ${y})`}>
            <polygon points={top} fill={tint[0]} />
            <polygon points={left} fill={tint[1]} />
            <polygon points={right} fill={tint[2]} />
        </g>
    );
}

type CubeMarkProps = {
    className?: string;
    title?: string;
};

export default function CubeMark({ className, title }: CubeMarkProps) {
    return (
        <svg
            className={className}
            viewBox='-21.6 -21 43.2 42'
            xmlns='http://www.w3.org/2000/svg'
            role={title ? 'img' : 'presentation'}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            focusable='false'
        >
            <TumblingCube x={0} y={0} size={22} spin={-18} tint={INDIGO} />
        </svg>
    );
}
